// extracted by mini-css-extract-plugin
module.exports = {"powersList":"CharacterBuilderClassPowers_powersList_1E7En"};